/**
 * The verdict outcomes, defined ONCE (#458).
 *
 * There were three copies: VerdictForm and VerdictResult held this list, and
 * BoutDetail held an older one with TKO and RSC, codes the backend refuses,
 * so a real verdict such as RSCB showed as the raw code there.
 *
 * The codes mirror `VALID_OUTCOMES` in backend/src/routes/verdict.ts, and
 * `bout-outcome-parity-458.spec.ts` pins the two. Muaythai terms stay
 * English in every language.
 */
export const BOUT_OUTCOMES: readonly { code: string; label: string }[] = [
  { code: 'WP',   label: 'Win on Points' },
  { code: 'KO',   label: 'Knock-Out' },
  { code: 'KOB',  label: 'KO — Body' },
  { code: 'KOH',  label: 'KO — Head' },
  { code: 'CCL',  label: 'Compulsory Count Limit' },
  { code: 'RET',  label: 'Retirement' },
  { code: 'DQ',   label: 'Disqualification' },
  { code: 'DRAW', label: 'Draw' },
  { code: 'NC',   label: 'No Contest' },
  { code: 'RSCB', label: 'RSC — Body' },
  { code: 'RSCH', label: 'RSC — Head' },
  { code: 'RSCI', label: 'RSC — Injury' },
  { code: 'RSCS', label: 'RSC — Safety' },
  { code: 'WO',   label: 'Walk Over' },
];

/** The label of an outcome code; an unknown code shows as itself. */
export function outcomeLabel(code: string | null | undefined): string {
  if (!code) return '';
  return BOUT_OUTCOMES.find(o => o.code === code)?.label ?? code;
}
